/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unlock_Land_Confirm_TitleInputs */

const en_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock this Land Style?`)
};

const ar_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل تريد فتح نمط الأرض هذا؟`)
};

const de_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Land-Stil freischalten?`)
};

const es_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desbloquear este estilo de terreno?`)
};

const fr_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débloquer ce style de sol ?`)
};

const it_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccare questo stile del terreno?`)
};

const ja_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このランドスタイルをアンロックしますか？`)
};

const ko_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 랜드 스타일을 잠금 해제할까요?`)
};

const pt_br_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear este estilo de terreno?`)
};

const ru_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать этот стиль земли?`)
};

const th_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดล็อกสไตล์พื้นดินนี้ไหม?`)
};

const tr_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Arazi Türünün kilidi açılsın mı?`)
};

const zh_cn_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解锁此土地皮肤？`)
};

const zh_tw_unlock_land_confirm_title = /** @type {(inputs: Unlock_Land_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`解鎖此土地造型？`)
};

/**
* | output |
* | --- |
* | "Unlock this Land Style?" |
*
* @param {Unlock_Land_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const unlock_land_confirm_title = /** @type {((inputs?: Unlock_Land_Confirm_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unlock_Land_Confirm_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unlock_land_confirm_title(inputs)
	if (locale === "ar") return ar_unlock_land_confirm_title(inputs)
	if (locale === "de") return de_unlock_land_confirm_title(inputs)
	if (locale === "es") return es_unlock_land_confirm_title(inputs)
	if (locale === "fr") return fr_unlock_land_confirm_title(inputs)
	if (locale === "it") return it_unlock_land_confirm_title(inputs)
	if (locale === "ja") return ja_unlock_land_confirm_title(inputs)
	if (locale === "ko") return ko_unlock_land_confirm_title(inputs)
	if (locale === "pt_br") return pt_br_unlock_land_confirm_title(inputs)
	if (locale === "ru") return ru_unlock_land_confirm_title(inputs)
	if (locale === "th") return th_unlock_land_confirm_title(inputs)
	if (locale === "tr") return tr_unlock_land_confirm_title(inputs)
	if (locale === "zh_cn") return zh_cn_unlock_land_confirm_title(inputs)
	return zh_tw_unlock_land_confirm_title(inputs)
});